import config from '../config';

function getIdentityOriginUrl() {
  return new URL(String(config.identityEndpoint)).origin;
}

export default getIdentityOriginUrl;
